module.exports = __webpack_public_path__ + "static/cpt-bw-a99da49f1af555be2fc969baae67e267.png";